import {_} from 'lodash';
import {IKnockoutComponent, IRouteDefinition, ISyncstep} from "../../../index";
import * as ko from "knockout";
import {getObjectDefinition, IObjectDefinition} from "../../../util/misc";
import {ObjectTypeId} from "../../../constants";
import {getRouteDefinition} from "../../../constants/RouteDefinitions";
import invalid_anchorHtml from './invalid.anchor.html?raw';

export let template = invalid_anchorHtml;

interface IParams {
    syncstep: ISyncstep
}

interface IObjectType {
    objectTypeId: ObjectTypeId
    objDef: IObjectDefinition
}

export class viewModel {

    private availableObjectTypes: IObjectType[];
    private selectedObjectType: KnockoutObservable<IObjectType | null> = ko.observable(null);
    private syncstep: ISyncstep;

    constructor(params: IParams) {
        this.syncstep = params.syncstep;
        const objectTypeIds: ObjectTypeId[] = [ObjectTypeId.User, ObjectTypeId.Department, ObjectTypeId.Group];
        this.availableObjectTypes = objectTypeIds.map(objectTypeId => {
            return {
                objectTypeId,
                objDef: getObjectDefinition(objectTypeId)!,
            }
        })
    }

    private getComponent(): IKnockoutComponent | null {
        const type = this.selectedObjectType();
        if (!type) {
            return null;
        }
        const routeDef = getRouteDefinition(type.objDef.routeSearch!);
        if (!routeDef) {
            return null;
        }
        return _.defaultsDeep(routeDef.component as IKnockoutComponent, {
            params: {
                syncstepid: this.syncstep.id,
                isSelectable: true,
                selectedObjects: ko.observableArray(null),
                objectTypeId: type.objectTypeId,
            },
        });
    }

}
